import { PropertyDataContext, Property } from "./_types";

export const LIB_PROPERTIES: Property[] = [
    {
        id: "prop_sample_description",
        label: "Description",
        field: 'sampleDescription',
        fieldAggr: 'sampleDescription',
        width: 100,
        context: PropertyDataContext.SAMPLE,
    },
    {
        id: "prop_sample_label",
        label: "Sample Label",
        field: 'sampleLabel',
        fieldAggr: 'sampleLabel',
        width: 100,
        context: PropertyDataContext.SAMPLE,
    },
    {
        id: "prop_cultivar",
        label: "Scion Cultivar",
        field: "scionCultivarLabel",
        width: 100,
        context: PropertyDataContext.CULTIVAR,
    },
    {
        id: "prop_rootstock",
        label: "Rootstock Cultivar",
        field: "rootstockCultivarLabel",
        width: 100,
        context: PropertyDataContext.SAMPLE,
    },
    {
        id: "prop_size",
        label: "Sample Size",
        field: 'evalSize',
        fieldAggr: "sampleSize",
        width: 100,
        context: PropertyDataContext.SAMPLE,
    },
    // TODO ADD EVAL SIZE
    {
        id: "prop_row_pos",
        label: "Row & Position",
        field: "rowPos",
        width: 100,
        context: PropertyDataContext.SAMPLE,
    },
    {
        id: "prop_eval_label",
        label: "Evaluation Label",
        field: 'evalLabel',
        width: 100,
        context: PropertyDataContext.EVALUATION,
    },
    {
        id: "prop_eval_date",
        label: "Evaluation Date",
        field: 'startDate',
        width: 100,
        context: PropertyDataContext.EVALUATION,
    },
    {
        id: "prop_planted_year",
        label: "Planted Year",
        field: "samplePlantedYear",
        width: 100,
        context: PropertyDataContext.SAMPLE,
    },
    {
        id: "prop_harvest_date",
        label: "Plant/Harvest Date",
        field: 'sampleBirthDate',
        width: 100,
        context: PropertyDataContext.SAMPLE,
    },
    {
        id: "prop_death_date",
        label: "Grubbed/Destroyed Date",
        field: 'sampleDeathDate',
        width: 100,
        context: PropertyDataContext.SAMPLE,
    },
    {
        id: "prop_eval_notes",
        label: "Evaluation Notes",
        field: "notes",
        width: 300,
        context: PropertyDataContext.EVALUATION,
    },

    // SITE — Basic Info, matches Add Site form field order
    {
        id: "prop_site_name",
        label: "Site Name",
        field: "siteName",
        width: 100,
        context: PropertyDataContext.SITE,
    },
    {
        id: "prop_site_block",
        label: "Block",
        field: "siteBlock",
        width: 100,
        context: PropertyDataContext.SITE,
    },
    {
        id: "prop_location",
        label: "Location",
        field: 'siteLabel',
        width: 100,
        context: PropertyDataContext.SITE,
    },
    {
        id: "prop_site_row_distance",
        label: "Row Spacing",
        field: "siteRowDistance",
        width: 100,
        context: PropertyDataContext.SITE,
    },
    {
        id: "prop_site_col_distance",
        label: "Column/Plant Spacing",
        field: "siteColDistance",
        width: 100,
        context: PropertyDataContext.SITE,
    },
    {
        id: "prop_site_narrow_row_distance",
        label: "Narrow Row Spacing",
        field: "siteNarrowRowDistance",
        width: 100,
        context: PropertyDataContext.SITE,
    },

    // SITE — Geolocation, matches Add Site form field order
    {
        id: "prop_site_lat",
        label: "Latitude",
        field: "siteLat",
        width: 100,
        context: PropertyDataContext.SITE,
    },
    {
        id: "prop_site_lng",
        label: "Longitude",
        field: "siteLng",
        width: 100,
        context: PropertyDataContext.SITE,
    },
    {
        id: "prop_site_area",
        label: "Area",
        field: "siteArea",
        width: 100,
        context: PropertyDataContext.SITE,
    },
    {
        id: "prop_location_alt",
        label: "Location Altitude",
        field: 'siteAlt',
        width: 100,
        unit: 'm',
        context: PropertyDataContext.SITE,
    },
    {
        id: "prop_chilling_units",
        label: "Chilling Units",
        field: 'siteChillingUnits',
        width: 100,
        context: PropertyDataContext.SITE,
    },

    // SITE — Address, matches Add Site form field order
    {
        id: "prop_site_addr_street",
        label: "Street Address",
        field: "siteAddrStreet",
        width: 100,
        context: PropertyDataContext.SITE,
    },
    {
        id: "prop_site_addr_city",
        label: "City",
        field: "siteAddrCity",
        width: 100,
        context: PropertyDataContext.SITE,
    },
    {
        id: "prop_site_addr_region",
        label: "Region",
        field: "siteAddrRegion",
        width: 100,
        context: PropertyDataContext.SITE,
    },
    {
        id: "prop_site_addr_district",
        label: "District",
        field: "siteAddrDistrict",
        width: 100,
        context: PropertyDataContext.SITE,
    },
    {
        id: "prop_site_addr_ward",
        label: "Ward",
        field: "siteAddrWard",
        width: 100,
        context: PropertyDataContext.SITE,
    },
    {
        id: "prop_site_addr_code",
        label: "Postal Code",
        field: "siteAddrCode",
        width: 100,
        context: PropertyDataContext.SITE,
    },
    {
        id: "prop_site_addr_country",
        label: "Country",
        field: "siteAddrCountry",
        width: 100,
        context: PropertyDataContext.SITE,
    },

    // SITE — rollups computed across the site's samples, not on the Add Site form
    {
        id: "prop_site_plant_sample_count",
        label: "Plant Sample Count",
        field: "sitePlantSampleCount",
        width: 100,
        context: PropertyDataContext.SITE,
    },
    {
        id: "prop_site_harvest_sample_count",
        label: "Harvest Sample Count",
        field: "siteHarvestSampleCount",
        width: 100,
        context: PropertyDataContext.SITE,
    },
    {
        id: "prop_site_cultivar_count",
        label: "Cultivar Count",
        field: "siteCultivarCount",
        width: 100,
        context: PropertyDataContext.SITE,
    },

    // MISCELLANEOUS — kept last so this category sits at the bottom of the property picker
    {
        id: "prop_tree_count",
        label: "Tree Count",
        field: "sampleTreeCount",
        width: 100,
        context: PropertyDataContext.MISCELLANEOUS,
    },
    {
        id: "prop_fruit_count",
        label: "Fruit Count",
        field: "sampleFruitCount",
        width: 100,
        context: PropertyDataContext.MISCELLANEOUS,
    },
    {
        id: "prop_treatment",
        label: "Treatment Type",
        field: "storageRegime",
        width: 100,
        context: PropertyDataContext.MISCELLANEOUS,
    },

];
